module.exports = __webpack_public_path__ + "3705a552e0b411d64647cc1bfd0c7f27.pdf";